/**
 * Client-side Story model: reactive reads of `stories/{id}`. The rules let a signed-in user read only
 * published stories, so every query must carry `where('status', '==', 'published')` — see `StoriesState`.
 */

import type { FirestoreContainer } from '#containers/FirestoreContainer.js';
import type { ClientInstanceOf } from '#firebase/types.js';

import { StoryModelSpec } from '@elara/domain/models/StoryModelSpec';

import { createClientModel } from '#firebase/createClientModel.js';

export function createClientStoryModel(firestore: FirestoreContainer) {
  return createClientModel(firestore, StoryModelSpec, () => ({}));
}

export type ClientStoryModel = ReturnType<typeof createClientStoryModel>;
export type StoryDocument = ClientInstanceOf<ClientStoryModel>;
